import type { ReactNode } from 'react';

interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  meta?: ReactNode;
}

/**
 * Page-level header. Brand spec — F37 Ginger Light, ALL CAPS,
 * tracking-heading (0.20em). Charcoal Black label per §3.17.
 */
export function PageHeader({ eyebrow, title, meta }: PageHeaderProps) {
  return (
    <header className="mb-6">
      {eyebrow && <p className="eyebrow mb-2">{eyebrow}</p>}
      <div className="flex items-baseline justify-between gap-6 flex-wrap">
        <h1 className="m-0 font-light uppercase tracking-heading text-h2 text-fg-default">{title}</h1>
        {meta && <div className="text-fg-muted text-small">{meta}</div>}
      </div>
      <hr className="mb-rule--accent mt-4" />
    </header>
  );
}
